/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Ref_N4Inputs */

const en_to_typescript_ref_n4 = /** @type {(inputs: To_Typescript_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A mixed array becomes a union of the element types it observed.`)
};

const ko_to_typescript_ref_n4 = /** @type {(inputs: To_Typescript_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`혼합 배열은 관찰된 요소 타입들의 유니온이 됩니다.`)
};

const ja_to_typescript_ref_n4 = /** @type {(inputs: To_Typescript_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`混在した配列は、観測された要素型のユニオンになります。`)
};

/**
* | output |
* | --- |
* | "A mixed array becomes a union of the element types it observed." |
*
* @param {To_Typescript_Ref_N4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_ref_n4 = /** @type {((inputs?: To_Typescript_Ref_N4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Ref_N4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_ref_n4(inputs)
	if (locale === "ko") return ko_to_typescript_ref_n4(inputs)
	return ja_to_typescript_ref_n4(inputs)
});